export default {
    meta: {
        title: '踩点记录',
        url: '/spotsurvey/edit',
        urlName: '踩点记录',
    }
};
